import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Switch, message } from 'antd';
import { Colors } from '../../helpers/Colors';
import DynamicTable from '../TableComponents/DynamicTable';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { AddLocomotiveNotes, createContact, deleteContact, getAllContacts, getAllNotes } from '../../Services/LocomotiveServices';
import moment from 'moment';
import roleManager from '../roles';
import { formatPhoneNumber } from '../../helpers/formatedNumber';
import DynamicFormFieldsAntd from '../InputComponents/DynamicFormFIeldsAntd';
const ContractModal = ({ open, close, data }) => {
    const [newContract, setNewContract] = useState(false)
    const [TableData, setTableData] = useState([])
    const [SwitchStatus, setSwitchStatus] = useState(false)
    const [Office, setOffice] = useState()
    const [Mobile, setMobile] = useState()
    const [form] = Form.useForm()
    const [isLoading, setLoading] = useState(false); // New loading state

    const formFields = [
        {
            name: "Name",
            require: true,
            type: "Text",
            key: "Name"
        },
        {
            name: "Title",
            require: true,
            type: "Text",
            key: "Title"
        },
        {
            name: "Email",
            require: false,
            type: 'Text',
            key: "Email"
        },

    ]

    let table = {
        header: [
            "ID",
            "Name",
            "Title",
            "Office",
            "Mobile",
            "Email",
            "Date Added",
            SwitchStatus && "Deleted Date",
            roleManager("locomotive", "lookupEdit", "addContact") && !SwitchStatus && "Actions"
        ],
        rows: TableData?.map(row => [
            row?.id,
            row?.CustName,
            row?.CustTitle,
            formatPhoneNumber(row?.CustOffice),
            formatPhoneNumber(row?.CustMobile),
            row?.CustEmail,
            moment(row?.createdAt).format('MM-DD-YYYY ') || "N/A",
            SwitchStatus && row?.deletedAt && moment(row?.deletedAt).format('MM-DD-YYYY'),
            roleManager("locomotive", "lookupEdit", "addContact") && !SwitchStatus && <Button onClick={() => {
                deleteContacts(row?.id)
            }}><DeleteOutlined style={{ color: "red" }} /></Button>
        ])
    }

    const getContacts = async () => {
        const result = await getAllContacts(data?.id, SwitchStatus ? 1 : 0)
        if (result.httpStatus === 200) {
            setTableData(result?.data)
        }
    }
    const deleteContacts = async (id) => {
        const obj = {
            contactId: id
        }
        const result = await deleteContact(data.id, obj)
        if (result?.httpStatus === 200) {
            message.success('Contact deleted sucessfully')
            getContacts()
        }
    }
    const CheckLength = (num, name) => {
        if (num) {
            if (num.length === 14) {
                return false
            }
            message.error(`${name} No is not valid `);
            return true

        }
        return false
    }
    const HandleSubmit = async (values) => {
        if (isLoading) {
            // If the form is already submitting, exit the function to avoid duplicate API calls
            return;
        }

        try {
            setLoading(true); // Set loading state to true to prevent duplicate submissions

            let check1 = CheckLength(Mobile, "Mobile");
            let check2 = CheckLength(Office, "Office");

            if (check1 || check2) {
                // If length checks fail, reset the loading state
                setLoading(false);
                return;
            }

            const dataobj = {
                CustName: values?.Name,
                CustMobile: Mobile,
                CustOffice: Office,
                CustEmail: values?.Email,
                CustTitle: values?.Title,
            };

            const result = await createContact(data?.id, dataobj);

            if (result?.httpStatus === 200) {
                message.success('Contact created successfully!');
                getContacts();
                setMobile(null); 
                setOffice(null);  
                form.setFieldsValue({
                    Name: '',
                    Title: '',
                    Email: '',
                });
                setNewContract(false);
            }
        } catch (error) {
            // Handle error as needed
        } finally {
            setLoading(false); // Set loading state to false after the API call completes
        }
    };

    // const HandleSubmit = async (values) => {


    //     let check1 = CheckLength(Mobile, "Mobile")
    //     let check2 = CheckLength(Office, "Office")
    //     if (check1 || check2) { return }
    //     const dataobj = {
    //         CustName: values?.Name,
    //         CustMobile: Mobile,
    //         CustOffice: Office,
    //         CustEmail: values?.Email,
    //         CustTitle: values?.Title
    //     }
    //     const result = await createContact(data?.id, dataobj)
    //     if (result?.httpStatus === 200) {
    //         message.success('Contact created successfully!');
    //         getContacts()
    //         setMobile(null);  // or setMobile('')
    //         setOffice(null);  // or setOffice('')
    //         setNewContract(false);
    //         form.setFieldsValue({
    //             Name: '',
    //             Title: '',
    //             Email: '',
    //         });            setNewContract(false)

    //     }
    // }


    const validateEmail = (key, value, callback) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (!value || emailRegex.test(value)) {
            callback();
        } else {
            callback('Please enter a valid email address');
        }
    }
    useEffect(() => {
        setNewContract(false)
        if (open) {
            getContacts()
        } else {
            setOffice()
            setMobile()
        }
    }, [open, SwitchStatus])

    return (
        <>

            <Modal width={newContract ? 500 : 900} title={<p style={{ color: Colors.mainBlue, fontWeight: "600", marginBottom: "0px ", fontSize: "20px" }}>Contacts </p>} open={open} onCancel={() => { setNewContract(false); close('contract') }} footer={null}>

                {
                    !newContract &&
                    <div style={{ marginBottom: "10px", display: 'flex', justifyContent: "space-between" }}>
                        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                            <p style={{ whiteSpace: 'nowrap', margin: "0px", padding: "0px", fontWeight: "bold", width: "" }}>
                                History
                            </p>
                            <Switch checked={SwitchStatus} onChange={(value) => { setSwitchStatus(value) }} />
                        </div>
                        {
                            roleManager("locomotive", "lookupEdit", "addContact") && data?.status?.status !== "DEL" &&
                            <Button onClick={() => { setNewContract(true) }} style={{ background: Colors.mainBlue, color: "white" }}><PlusOutlined /> Add Contact</Button>
                        }
                    </div>
                }
                <div style={{}}>
                    {
                        newContract ?
                            <Form form={form} name='equipID' onFinish={HandleSubmit} style={{ width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
                                    {
                                        formFields.map((item, index) => (
                                            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                                <p style={{ color: 'black', fontWeight: "700", fontSize: '15px', whiteSpace: "nowrap" }}>{item.name}</p>
                                                <Form.Item style={{ width: "100%", display: 'flex', justifyContent: "flex-end" }} name={item.key} rules={
                                                    [{ required: item.require, message: `${item.name} is required` }, item?.key === 'Email' && { validator: validateEmail, message: "Invalid Email format" }]}>
                                                    <Input value={item?.value} onChange={(event) => { if (item?.value) { item?.setValue(event?.target?.value) } }} type={item.type} placeholder={`Enter ${item.name}.`} style={{
                                                        background: 'none',
                                                        border: `1px solid lightgray`,
                                                        fontSize: "13px",
                                                        width: "300px"
                                                    }} />
                                                </Form.Item>

                                            </div>
                                        ))
                                    }
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                        <p style={{ color: 'black', fontWeight: "700", fontSize: '15px', whiteSpace: "nowrap" }}>Mobile Number</p>

                                        <Input value={Mobile} onChange={(event) => { setMobile(formatPhoneNumber(event?.target?.value)) }} placeholder={`Enter Mobile Number.`} style={{
                                            background: 'none',
                                            border: `1px solid lightgray`,
                                            fontSize: "13px",
                                            width: "300px"
                                        }} />

                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                        <p style={{ color: 'black', fontWeight: "700", fontSize: '15px', whiteSpace: "nowrap" }}>Office Number</p>
                                        <Input value={Office} onChange={(event) => { setOffice(formatPhoneNumber(event?.target?.value)) }} placeholder={`Enter Office Number.`} style={{
                                            background: 'none',
                                            border: `1px solid lightgray`,
                                            fontSize: "13px",
                                            width: "300px"
                                        }} />
                                    </div>
                                </div>
                                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                                    <Button htmlType='submit' style={{ background: Colors.mainBlue, color: "white" }}>
                                        Create
                                    </Button>
                                    <Button onClick={() => { setNewContract(false) }} style={{ background: 'white', color: Colors.mainBlue }}>
                                        Contact List
                                    </Button>
                                </div>
                            </Form>
                            :
                            <DynamicTable tableData={table} />
                    }
                </div>
            </Modal>
        </>
    );
};
export default ContractModal;